// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/circle-of-uncertainty.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/circle-of-uncertainty/circle-of-uncertainty.js';

mount([g0]);
